import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LegacyAuthenticationApiService {
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  // This should be moved into the oauth service when oauth migration is complete
  public logout(): Observable<void> {
    return this.httpClient.post<void>(this.rmaApiUrl('Account/logOut'), {});
  }
}
